
    import { Vue,Component,Prop } from 'vue-property-decorator'
    import { State,Action,namespace,Mutation } from 'vuex-class'
    import PagedTable from './common/pagedTable.vue'
    import Partner from './partner.vue'
    import exicon, {defaulticon} from '../assets/expressicon'
    import dayjs from 'dayjs'
    const packageslist = namespace('packageslist')
    @Component({
        components: {
            PagedTable,
            Partner
        }
    })
    export default class NotOutbound extends Vue{
        exicon:any = exicon
        defaulticon:any = defaulticon
        multipleSelection:any = [] //勾选的项
        changeRowIdList:string = '' //修改的每一项的id集合
        @Prop({
            type: Array,
            default: []
        })
        list:any
        get tablecolumn(){
            return [
                {
                    prop: 'code',
                    name: 'code',
                    type: 'slot',
                    label: '快递单号',
                },
                {
                    prop: 'shelf',
                    name: 'shelf',
                    type: 'slot',
                    label: '货架'
                },
                {
                    prop: 'serial',
                    type: 'text',
                    label: '编号'
                },
                {
                    prop: 'phone',
                    name: 'phone',
                    type: 'slot',
                    label: '电话'
                },
                {
                    prop: 'partner',
                    name: 'partner',
                    type: 'slot',
                    label: '快递员'
                },
                {
                    prop: 'intime',
                    type: 'text',
                    label: '入库时间'
                },
                {
                    prop: 'desc',
                    name: 'desc',
                    type: 'slot',
                    label: '备注'
                },
                {
                    prop: 'name',
                    name:'operation',
                    type: 'slot',
                    label: '操作',
                }
            ]
        }
        @packageslist.Action('outbound') outbound:any //出库
        @packageslist.Action('againInbond') againInbond:any //重新入库
        // 勾选前面的选项时
        multiplechange(e:any){
            this.multipleSelection = e
            let data = e.map((item:any) => {
                return item._id
            })
            let partner = e.map((item:any) => {
                return item.partner.id
            })
            this.changeRowIdList = data.join(',')
        }
        // 单个出库
        async outboundOne(data:any,index?:number){
            let res;
            if(data.id){
                res = await this.outbound(data)
            }else{
                res = await this.outbound({id:data})
            }
            console.log(data);
            if(res){
                this.playChukuSuccess()
                // this.$message({ message: '出库成功', type: 'success' });
                this.$notify({
                    title: '成功',
                    message: '出库成功',
                    type: 'success'
                });
                if(index){
                    this.list[index].status = '1'
                }else{
                    if(index == 0){
                        this.list[index].status = '1'
                    }else{
                        this.$emit('hideDiadlong',true)
                    }
                }
            }else{
                this.playChukuFail()
            }
        }
        // 批量出库
        batchInbound(){
            if(this.multipleSelection.length > 0){
                const idList = this.multipleSelection.map((item:any) => item._id)
                this.outboundOne({
                    id:idList.join(','),
                    data:{problem: false},
                })
            }else{
                this.$message({
                    message: '请选择数据',
                    type: 'warning'
                });
            }
            
        }
        // 重新入库
        againInbondFun(id:string,index?:number){
            const res = this.againInbond(id)
            if(res){
                this.playRuSuccess()
                this.$message({ message: '重新入库成功', type: 'success' });
                if(index){
                    this.list[index].status = '0'
                }else{
                    this.$emit('hideDiadlong',true)
                }
            }else{
                this.playRukuFail()
            }
        }
        playChukuSuccess(){
			const audio = new Audio(require('../assets/chuku-success.mp3'));
			audio.play();
		}
		playChukuFail(){
			const audio = new Audio(require('../assets/chuku-fail.mp3'));
			audio.play();
        }
        playRukuFail(){
            const audio = new Audio(require('../assets/ruku-fail.mp3'));
            audio.play();
        }
        playRuSuccess(){
            const audio = new Audio(require('../assets/ruku-success.mp3'));
            audio.play();
        }
    }
